import {
  CLEAR_ALERT,
  DELETE_ARTIST_PICK,
  SAVE_ARTIST_PICK_V2,
  SET_ALERT,
  UPDATE_ARTISTS_PLAYLISTS,
} from '../actionTypes';

const DEFAULT_FAILURE = 'Something went wrong, please try again later.';
const DEFAULT_SUCCESS = 'Success!';
const DUPLICATE_PLAYLIST =
  'Try adding a different playlist. That one’s already on your profile.';
const ARTIST_PICK_V2_SUCCESS =
  'We saved your pick. Fans can see it on your profile now.';

export const alert = (state = null, action) => {
  switch (action.type) {
    case SET_ALERT:
      return { ...action.payload };
    case CLEAR_ALERT:
      return null;

    case SAVE_ARTIST_PICK_V2:
      if (action.error) {
        return {
          title: DEFAULT_FAILURE,
          error: true,
        };
      }

      if (action.payload) {
        return {
          title: ARTIST_PICK_V2_SUCCESS,
        };
      }
      return state;

    case DELETE_ARTIST_PICK:
      if (action.error) {
        return {
          title: DEFAULT_FAILURE,
          error: true,
        };
      }

      if (action.payload) {
        return {
          title: DEFAULT_SUCCESS,
        };
      }
      return state;

    case UPDATE_ARTISTS_PLAYLISTS:
      if (action.error) {
        return {
          title: DEFAULT_FAILURE,
          error: true,
        };
      }

      if (action.payload && action.payload.hasDuplicate) {
        return {
          title: DUPLICATE_PLAYLIST,
          error: true,
        };
      }

      if (action.payload) {
        return {
          title: DEFAULT_SUCCESS,
        };
      }
      return state;

    default:
      return state;
  }
};
